export default "__VITE_ASSET__DEr59DrZ__"